module.exports = __webpack_public_path__ + "app/assets/images/woman18-a002da66a728d4c02706cde07c5b853b.jpg";